<template>
  <b-modal
    id="show-xero-errors-modal"
    ref="show-xero-errors-modal"
    size="lg-size"
    modal-class="modal-xero"
    no-close-on-esc
    no-close-on-backdrop
    centered
    hide-footer
    hide-header
    @hide="close"
  >
    <div class="modal-head">
      <h2 class="modal-title">
        {{ "An Error Occurred!" }}
      </h2>
      <div class="quickbooks-logo">
        <img
          src="/assets/images/xero-logo-blue.svg"
          alt="Atto"
          class="black-logo"
          width="50"
          height="50"
        />
      </div>
    </div>
    <div class="content-wrapper">
      <p>
        {{
          "We’ve encountered an error and have failed to connect to your Xero account. Some of the reasons behind this error include:"
        }}
      </p>

      <div class="list-wrapper">
        <p>
          {{
            "• You’ve disconnected the integration to Atto on the Xero dashboard."
          }}
        </p>
        <p>{{ "• The free trial on your Xero account has ended." }}</p>
        <p>{{ "• You’ve deleted your Xero account." }}</p>
        <p>
          {{
            "• User permissions changed. The user who has authorized the connection between Atto and Xero has been removed or their role has changed."
          }}
        </p>
      </div>

      <p>This Issue Can Be Resolved In The Integrations Page.</p>
      <p>
        {{
          "Please review the above and contact us at support@attotime.com with additional info so we can help."
        }}
      </p>
    </div>
    <div class="modal-footer">
      <button
        type="reset"
        class="atto-btn close-btn"
        data-dismiss="modal"
        @click="close"
      >
        {{ label.get("close") }}
      </button>
    </div>
  </b-modal>
</template>

<script>
import CompanyService from "../services/CompanyService";
import SelectDropdownComponent from "../../../../shared/components/SelectDropdownComponent";

export default {
  name: "ShowXeroErrorsModalComponent",
  mounted() {
    document.body.appendChild(this.$el);
    this.$refs["show-xero-errors-modal"].show();
  },
  methods: {
    close() {
      this.$root.$emit("hideXeroErrors");
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-entry-delete {
  .modal-content {
    .modal-body {
      .content-wrapper {
        &.password-confirm.has-error {
          padding-bottom: 16px;
        }
      }
    }
  }
}

.modal-lg-size {
  .modal-content {
    .modal-body {
      .content-wrapper {
        display: flex;

        &.quickbooks-container {
          padding: 0 0 24px 0 !important;
          flex-direction: column;
        }

        h4 {
          font-weight: 400;
          font-size: 1rem;
          line-height: 1.25rem;
          margin-bottom: 16px;
          padding-left: 48px;
        }

        .list-wrapper {
          p {
            margin-bottom: 0;

            &:last-child {
              margin-bottom: 1rem;
            }
          }
        }
      }

      .field-row {
        display: flex;
        flex-direction: row;
        margin-bottom: 0px !important;
        align-items: center;
        position: relative;
        width: 100%;

        p.member-name {
          font-size: 0.875rem;
          line-height: 1.25rem;
          color: $atto-font-color;
          font-family: $roboto-font;
          font-weight: 400;
          margin-bottom: 0px;
        }

        input {
          border: 2px solid $atto-light-grey;
          padding: 8px 12px;
          font-size: 0.875rem;
          line-height: 1.25rem;
          font-family: $roboto-font;
          font-weight: $roboto-regular;
          color: $atto-font-color;
          width: 100%;
          max-width: 360px;
          -webkit-appearance: none;
          border-radius: 0;
          @include base-transition(ease all 0.1s);

          &:focus {
            border-color: $atto-dark-grey;
          }
        }

        input.error {
          border: 2px solid $atto-red;
        }

        .checkbox-wrapper {
          margin-right: 16px;
          width: 24px;
        }

        .check-wrapper {
          .custom-checkbox {
            margin-left: 14px;
          }
        }

        .member-name {
          flex-grow: 1;
        }

        .member-dropdown {
          width: calc(50% - 16px);
        }

        .atto-select {
          margin-right: 0;

          .select-heading {
            width: 100%;
            max-width: 360px;
            flex-direction: row;
            @include base-transition(ease all 0.1s);

            span {
              flex-grow: 1;
              display: inline-flex;
            }

            i {
              @include base-transition(ease all 0.1s);
            }

            &:hover {
              border-color: #c7c7c7;

              i {
                color: #c7c7c7;
              }
            }
          }

          .select-options {
            .heading {
              i {
                margin-right: 0;
                color: #c7c7c7;
              }
            }
          }
        }
      }
    }
  }
  .modal-content .modal-footer .atto-btn.cancel {
    margin-right: 0;
  }
}

.password-confirm {
  p {
    margin-bottom: 12px !important;
    text-align: left !important;
  }

  input {
    width: 100%;
    border: 2px solid #efefef;
    padding: 5px 10px;
    font-family: "Roboto", sans-serif;
    line-height: 36px;
    color: #262626;

    &:focus {
      border-color: #00b9cb;
    }
  }
}
</style>
